import React from "react";
import styled from "styled-components";
import { AiOutlineGithub, AiOutlineInstagram } from "react-icons/ai";
import { Slide } from "react-awesome-reveal";
import imgSelf from '../../assets/img/imag_portafolio_juan.png';

const ProfComponent = () => {

  const sendByChat = (event) => {
    event.preventDefault();
    window.open("https://wa.link/xb51vd");
  }
  return (
    <Container id="home">
      <Slide direction="left">
        <Texts>
          <h4>
            Hola <span className="green">Yo soy</span>
          </h4>
          <h1 className="green">Juan Fernando Zuluaga</h1>
          <h3>Desarrollador Full-Stack y diseñador UX</h3>
          <p>
            Desarrollador Full-Stack con especialización en Diseño de Experiencia de Usuario (UX), fusionando habilidades técnicas para concebir soluciones integrales y centradas en las necesidades del usuario.
          </p>
          <button onClick={sendByChat}>Hablemos</button>
          <Social>
            <p>Echame un vistazo</p>
            <div className="social-icons">
              <span>
                <a href="https://www.instagram.com/developer__juan/">
                  <AiOutlineInstagram />
                </a>
              </span>
              <span>
                <a href="https://github.com/USER-2020">
                  <AiOutlineGithub />
                </a>
              </span>
              {/* <span>
                <a href="/">
                  <FaLinkedinIn />
                </a>
              </span> */}
            </div>
          </Social>
        </Texts>
      </Slide>
      <Slide direction="right">
        <Profile>
          <img
            src={imgSelf}
            alt="profile"
          />
        </Profile>
      </Slide>
    </Container>
  );
};

export default ProfComponent;

const Container = styled.div`
  display: flex;
  gap: 2rem;
  padding-top: 3rem;
  width: 80%;
  max-width: 1280px;
  margin: 0 auto;
  z-index: 1;
  @media (max-width: 840px) {
    width: 90%;
  }

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;
const Texts = styled.div`
  flex: 1;
  h4 {
    padding: 1rem 0;
    font-weight: 500;
  }
  h1 {
    font-size: 2rem;
    font-family: "Secular One", sans-serif;
    letter-spacing: 2px;
  }
  h3 {
    font-weight: 500;
    font-size: 1.2rem;
    padding-bottom: 1.2rem;
    text-transform: capitalize;
  }
  p {
    font-weight: 300;
  }

  button {
    padding: 0.7rem 2rem;
    margin-top: 3rem;
    cursor: pointer;
    background-color: #01be96;
    border: none;
    color: #fff;
    font-weight: 500;
    filter: drop-shadow(0px 10px 10px #01be9551);
    :hover {
      filter: drop-shadow(0px 10px 10px #01be9570);
    }
  }
`;
const Social = styled.div`
  margin-top: 3rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  p {
    font-size: 0.9rem;
    @media (max-width: 690px) {
      font-size: 0.7rem;
    }
  }

  .social-icons {
    display: flex;
    align-items: center;
    gap: 1rem;
    span {
      width: 2.3rem;
      height: 2rem;
      clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
      background-color: #01be96;
      position: relative;
      transition: transform 400ms ease-in-out;
      :hover {
        transform: rotate(360deg);
      }
    }

    a {
      color: #fff;
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const Profile = styled.div`
  img {
    width: 25rem;
    filter: drop-shadow(0px 10px 10px #01be9570);
    transition: transform 400ms ease-in-out;
    @media (max-width: 790px) {
      width: 20rem;
    }

    @media (max-width: 660px) {
      width: 18rem;
    }

    @media (max-width: 640px) {
      width: 100%;
    }
  }

  :hover img {
    transform: translateY(-10px);
  }
`;
